// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"21c0cf22","352":"9bc855de","571":"427d38ed","720":"427d38ed","968":"427d38ed","977":"427d38ed","986":"427d38ed"}[chunkId] + ".chunk.css";
};